/* This is the component that will contain almost everything from the right-hand side of your existing BusinessSmartTemplateStep6.

My goal is that WaiverContentSectionEditor contains zero business logic. It should simply render whatever the parent passes it. */
import { RichTextEditor } from "../../../../components/RichTextEditor";

import {
    replacePlaceholders,
    fixProseSpacing,
    normalizeHtmlEntities,
} from "../../../../api/helpers";

const WaiverContentSectionEditor = ({
    activeSection,
    governingData,
    saving,
    editorKey,
    phValues,
    updateContent,
    isReadOnly = false,
}) => {

    if (!activeSection) return null;

    return (

        <div className="flex-1 bg-white rounded-xl shadow-sm">

            {/* Header */}

            <div className="border-b px-6 py-4">

                <div className="font-semibold">
                    {normalizeHtmlEntities(activeSection.title)}
                </div>

                <div className="text-sm text-muted-foreground">

                    {activeSection.status === "locked"
                        ? "This section is locked and cannot be edited."
                        : "Edit the content of this section."}

                </div>

            </div>

            {/* Body */}

            <div className="p-6">

                {/* Governing Laws */}

                {activeSection.system ? (

                    <div className="space-y-8">

                        {governingData.map((item, idx) => (

                            <div
                                key={idx}
                                className="border rounded-lg p-6"
                            >

                                <h3 className="text-xl font-semibold mb-3">

                                    {item.locationName} ({item.state})

                                </h3>

                                <div
                                    className="prose max-w-none"
                                    dangerouslySetInnerHTML={{
                                        __html: fixProseSpacing(
                                            normalizeHtmlEntities(
                                                replacePlaceholders(
                                                    item.clause,
                                                    phValues,
                                                    true,
                                                    false
                                                )
                                            )
                                        ),
                                    }}
                                />

                            </div>

                        ))}

                    </div>

                )

                /* Locked Section */

                : activeSection.status === "locked" ? (

                    <div
                        className="
                            prose
                            max-w-none
                            [&_ul]:list-disc
                            [&_ul]:ml-6
                            [&_ol]:list-decimal
                            [&_ol]:ml-6
                            [&_li]:mb-2
                            [&_p]:mb-4
                        "
                        dangerouslySetInnerHTML={{
                            __html: fixProseSpacing(
                                normalizeHtmlEntities(
                                    replacePlaceholders(
                                        activeSection.content,
                                        phValues,
                                        true,
                                        false
                                    )
                                )
                            ),
                        }}
                    />

                )

                /* Editable Section */

                : (

                    <RichTextEditor
                        key={editorKey}
                        content={activeSection.content}
                        onChange={updateContent}
                        readOnly={isReadOnly}
                    />

                )}

            </div>

            {!isReadOnly && (

                <div className="border-t px-6 py-3 text-sm text-muted-foreground flex items-center gap-2">

                    <div className="w-3 h-3 border rounded-full" />

                    {saving
                        ? "Saving..."
                        : "Changes saved"}

                </div>

            )}

        </div>

    );

};

export default WaiverContentSectionEditor;